/**
 * useAuthStatus Hook
 *
 * Hook for checking authentication loading and error states.
 * Useful for showing loading spinners during auth initialization.
 */

import { useAuth0 } from "@auth0/auth0-react";

export function useAuthStatus() {
  const { isLoading, isAuthenticated, error } = useAuth0();

  return {
    isLoading,
    isAuthenticated,
    error,
    isReady: !isLoading,
  };
}
